import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SignupStateService } from '../../services/signup-state.service';

@Component({
  selector: 'app-account-type-step',
  templateUrl: './account-type-step.component.html',
  styleUrls: ['./account-type-step.component.sass'],
})
export class AccountTypeStepComponent implements OnInit {
  otpServiceDown = false;
  checkingService = true;

  constructor(
    public signupState: SignupStateService,
    private http: HttpClient
  ) {}

  async ngOnInit(): Promise<void> {
    await this.checkOtpService();
  }

  private async checkOtpService(): Promise<void> {
    const url = `${environment.apiKyc}otp/health`;
    const headers = new HttpHeaders({ skip: 'true' });

    try {
      const res: any = await firstValueFrom(this.http.get(url, { headers }));
      // Respuesta directa: { status: 'ok' } o envuelta en wrapper: { data: { status: 'ok' } }
      const data = res?.data || res;
      this.otpServiceDown = data?.status !== 'ok';
    } catch {
      this.otpServiceDown = true;
    } finally {
      this.checkingService = false;
    }
  }

  async selectAccountType(type: 'personal' | 'empresas'): Promise<void> {
    if (this.otpServiceDown) return;
    this.signupState.setAccountType(type);
    await this.signupState.nextStep();
  }
}
